export const MCP_URL = 'https://mcp.well-played.gg/mcp';
export const LLMS_TXT_URL = 'https://mcp.well-played.gg/llms.txt';
export const LLMS_FULL_TXT_URL = 'https://mcp.well-played.gg/llms-full.txt';
export const SCHEMA_SDL_URL = 'https://mcp.well-played.gg/schema.graphql';

export const CLAUDE_CODE_INSTALL_SNIPPET = `{
  "mcpServers": {
    "wellplayed": {
      "type": "http",
      "url": "${MCP_URL}"
    }
  }
}`;

export const ZERO_CLICK_SNIPPET = `# Install the CLI
npm install -g @well-played.gg/cli

# Authenticate (opens your browser)
wellplayed login

# Scaffold a fully-wired Vite + React + TypeScript project
wellplayed create-app my-site --framework vite-react

# Open the project in Claude Code and start building
cd my-site && claude`;

interface ExamplePrompt {
  title: string;
  body: string;
}

export const EXAMPLE_PROMPTS: ReadonlyArray<ExamplePrompt> = [
  {
    title: 'Add a tournaments list',
    body: 'Show a paginated list of tournaments from my organization with a filter by status. Use getMyAccount permissions to gate the "Create tournament" button.',
  },
  {
    title: 'Generate a webhook handler',
    body: 'Generate a typed webhook handler for TOURNAMENT_TEAM_STATUS_UPDATED using @well-played.gg/typescript-sdk.',
  },
  {
    title: 'Build a Discord bot',
    body: 'Build a Discord bot that announces new events using client credentials.',
  },
  {
    title: 'Gate UI by permission',
    body: 'Gate this route by the "tournament:manage" permission using the permissions returned from getMyAccount.',
  },
];

export const BANNER_PREFERENCE_KEY = 'ai_devex_banner_seen';
